import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState } from 'vuex';
import { stepForm } from '~/mixins';
import { required, numeric } from 'vuelidate/lib/validators';
import { TypeOSVEnum } from '@affiliation/enums';
import loader from '../modals/loader';

export default {
    mixins: [stepForm],
    components: {
        loader: loader
    },
    data: function data() {
        // const { commercialCode, osvType } = this.$store.state.affiliations.form.osvType
        // const indexOsvType = this.$store.state['master-data'].osvTypes.findIndex(ot => ot.value == osvType)
        // console.log(commercialCode);
        // console.log(osvType);
        // console.log(this.$store.state['master-data'].osvTypes)

        return {
            // commercialCode,
            // osvType: indexOsvType,
            sending: false,
            modalityOptions: [{ title: "Venta", content: "Ideal para adquirir el producto de manera permanente.", icon: ['fas', 'cart-arrow-down'], color: { color: '#f7c644' } }, { title: "Alquiler", content: "Ideal para adquirir el producto de manera temporal.", icon: ['fas', 'truck-moving'], color: { color: '#f7c644' } }],
            selectedIndex: null,
            check: ''
        };
    },
    validations: function validations() {
        var validations = {
            selectedIndex: { required: required }
        };

        return validations;
    },

    methods: {
        onSubmit: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var modality;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.$v.$touch();
                                this.errorMessage = null;

                                if (!this.$v.$invalid) {
                                    _context.next = 4;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 4:

                                this.sending = true;
                                this.$refs.loaderModal.showLoader();

                                modality = this.modalityOptions[this.selectedIndex];
                                _context.prev = 7;
                                _context.next = 10;
                                return this.$store.dispatch("affiliations/form/modalityType", {
                                    type: modality.title
                                });

                            case 10:
                                _context.next = 15;
                                break;

                            case 12:
                                _context.prev = 12;
                                _context.t0 = _context['catch'](7);

                                this.$controlMessage(_context.t0);

                            case 15:
                                this.sending = false;
                                this.$refs.loaderModal.closeLoader();

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[7, 12]]);
            }));

            function onSubmit() {
                return _ref.apply(this, arguments);
            }

            return onSubmit;
        }()
    },
    computed: {
        // ...mapState({
        //     _osvTypes: state => state['master-data'].osvTypes
        // }),
        // osvTypes() {
        //     return this._osvTypes.map(ot => {
        //         const newOt = { ...ot }
        //         switch (ot.value) {
        //             case TypeOSVEnum.INDIVIDUAL_INSTALATION: newOt.icon = 'icon-ic-registro-individual'; break;
        //             case TypeOSVEnum.FATHER_MULTICOMMERCE_INSTALLATION: newOt.icon = 'icon-ic-registro-padre'; break;
        //             case TypeOSVEnum.REGISTRATION_OF_CODE_SON: newOt.icon = 'icon-ic-registro-hijo'; break;
        //         }
        //         return newOt
        //     })
        // },
        // selectedOsvType() {
        //     return this.osvTypes.find((ot, index) => index === this.osvType)
        // },
        // commercialCodeErrorMessages(){
        //     return [
        //         !this.$v.commercialCode.$dirty || this.$v.commercialCode.required || 'Campo obligatorio',
        //         this.$v.commercialCode.$dirty || this.$v.commercialCode.numeric || 'Ingresa sólo números',
        //     ]
        //     .filter( val => typeof(val) == 'string')
        // },
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/osv-type.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/osv-type.vue
// module chunks = 0 1 2 3